import { createFileRoute } from "@tanstack/react-router";
import { Hub } from "./free-tools/index";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "170+ Free Classroom Tools, Calculators & PDF Utilities | Picamini.online" },
      {
        name: "description",
        content:
          "170+ free online tools for teachers & students — random name pickers, spin the wheel, team generators, 122+ calculators (percentage, BMI, mortgage), and private PDF tools. No signup, 100% browser-based.",
      },
      {
        name: "keywords",
        content:
          "picamini, free online tools, random name picker, spin the wheel, wheel of names, team generator, online calculators, percentage calculator, mortgage calculator, bmi calculator, pdf tools online, private pdf editor",
      },
      { property: "og:site_name", content: "Picamini.online" },
      { property: "og:title", content: "170+ Free Classroom Tools, Calculators & PDF Utilities | Picamini.online" },
      {
        property: "og:description",
        content:
          "170+ free interactive browser tools: random name pickers, spinner wheels, 122+ calculators, and client-side PDF utilities. 100% private & instant.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://picamini.online/" },
      { property: "og:image", content: "https://picamini.online/og-image.png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: "Picamini.online Free Classroom Tools, Calculators & Utilities" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "170+ Free Classroom Tools, Calculators & PDF Utilities | Picamini.online" },
      { name: "twitter:description", content: "170+ free interactive tools: name pickers, spinner wheels, 122+ calculators & PDF utilities." },
      { name: "twitter:image", content: "https://picamini.online/og-image.png" },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/" },
      { rel: "alternate", hrefLang: "fr", href: "https://picamini.online/fr/" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": "https://picamini.online/#webpage",
          "url": "https://picamini.online/",
          "name": "170+ Free Classroom Tools, Calculators & PDF Utilities",
          "description": "170+ free online tools for teachers & students — random name pickers, spin the wheel, team generators, 122+ calculators, and private PDF tools.",
          "isPartOf": { "@id": "https://picamini.online/#website" },
          "about": { "@id": "https://picamini.online/#organization" },
          "datePublished": "2024-01-15",
          "dateModified": "2026-09-15",
          "inLanguage": "en",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": ["h1", ".seo-intro"]
          }
        })
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Featured Classroom Tools, Calculators & PDF Utilities",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Random Name Picker",
              "url": "https://picamini.online/random-name-picker"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Spin the Wheel",
              "url": "https://picamini.online/spin-the-wheel"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Wheel of Names",
              "url": "https://picamini.online/wheel-of-names"
            },
            {
              "@type": "ListItem",
              "position": 4,
              "name": "Team Generator",
              "url": "https://picamini.online/team-generator"
            },
            {
              "@type": "ListItem",
              "position": 5,
              "name": "Classroom Timer",
              "url": "https://picamini.online/classroom-timer"
            },
            {
              "@type": "ListItem",
              "position": 6,
              "name": "Online Calculators Hub",
              "url": "https://picamini.online/calculators"
            },
            {
              "@type": "ListItem",
              "position": 7,
              "name": "Percentage Calculator",
              "url": "https://picamini.online/calculators/percentage-calculator"
            },
            {
              "@type": "ListItem",
              "position": 8,
              "name": "Mortgage Calculator",
              "url": "https://picamini.online/calculators/mortgage-calculator"
            },
            {
              "@type": "ListItem",
              "position": 9,
              "name": "BMI Calculator",
              "url": "https://picamini.online/calculators/bmi-calculator"
            },
            {
              "@type": "ListItem",
              "position": 10,
              "name": "PDF Toolkit Pro",
              "url": "https://picamini.online/pdf-tools"
            }
          ]
        })
      }
    ]
  }),
  component: Hub,
});
